import { Image } from '@shared/api/media/media.interface';
import { QueryDataState } from '@shared/interfaces';

import { User } from '../user/user.interface';

export enum EnquiryType {
  Bugo = 'Bugo',
  Store = 'Store',
  Seller = 'Seller',
}

export enum EnquiryStatus {
  Todo = 'Todo',
  Doing = 'Doing',
  Done = 'Done',
}

export type Enquiry<User = string, Image = string | null> = {
  _id: string;
  user: User;
  type: EnquiryType;
  title: string;
  name: string;
  phoneNumber: string;
  content: string;
  image: Image; // 이미지 없으면 ""
  answer: string;
  status: EnquiryStatus;
  //* 답변 제출(Done) 시 접수자에게 답변 LMS를 1회 보낸 시각. 발송 성공 시에만 기록되며
  //* 구서버·도입(2026-09-04) 전 답변·발송 실패면 없다. 비동기 발송이라 제출 직후엔 잠시 비어 있을 수 있다.
  answerNotifiedAt?: Date | string | null;
  createdAt: Date;
  updatedAt: Date;
};

export type EnquiryCreate = Omit<
  Enquiry,
  '_id' | 'createdAt' | 'updatedAt' | 'answer' | 'answerNotifiedAt'
>;

export type EnquiryList = Enquiry<User, Image>[];

export type EnquiryListState = QueryDataState<EnquiryList>;

export type UserEnquiryList = Enquiry<string, Image>[];

export type UserEnquiryListState = QueryDataState<UserEnquiryList>;

export type EnquiryUpdate = Pick<Enquiry, '_id' | 'answer' | 'status'>;
